import React from "react"

export default ({ useTopDivider, headline, children }) => (
    <>
        {useTopDivider && (
            <div className="divider divider-bottom bg-green"></div>
        )}
        <section className="bg-green text-white">
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-md-8 text-center">
                        <h1 className="display-4 mb-3 text-center">
                            {headline}
                        </h1>
                        <p className="lead">
                            Over 5 million people have found insurance by
                            shopping the nation's largest health insurance
                            marketplace.
                        </p>
                    </div>
                </div>
                {children}
            </div>
        </section>
    </>
)
